
import { ALTERAR_PERFIL, AuthPerfilActionTypes, AuthPerfilState } from "../../../types/authPerfil/authPerfil"

const INITIAL_STATE: AuthPerfilState = {
    perfilAtual: undefined
}

export function AuthPerfilReducer(state = INITIAL_STATE, action: AuthPerfilActionTypes): AuthPerfilState {
    switch (action.type) {
        case ALTERAR_PERFIL:
          return { ...state, perfilAtual: action.payload }
        default:
            return state
    }
}